import { ListItem, NumberedList, Link } from '@entur/typography';
import * as React from 'react';
export default {
  ListItem,
  NumberedList,
  Link,
  React
};